let timelineElements = [
    {
        id: 1,
        title: "Initialize Token",
        location: "August, 2021",
        // description:
        //     "Launch Community Group ✅, Launch Website ✅, Launch PEE Token ",
        description1: "• Launch Community Group ✅",
        description2: "• Launch Website ✅",
        description3: "• Launch PEE Token",
        buttonText: "On Going!",
        icon: "success",
    },
    {
        id: 2,
        title: "Marketing Phase",
        location: "September, 2021",
        // description:
        //     "Introducing Influencers and Collaborations With Key Market Players, 10k Holders, Further deployment of listings on several platforms",
        description1: "• 10k Holders",
        description2: "• Introducing Influencers",
        description3: "• Further listings platforms",
        description4: "• Collaborations with key market players",
        buttonText: "Coming Soon!",
        icon: "cms",
    },
    {
        id: 3,
        title: "Retain Holder",
        location: "October, 2021",
        // description:
        //     "Contract Logo, Reach 20k Holders, Reach 15k Telegram Members, Further Marketing",
        description1: "• Contract Logo",
        description2: "• Further Marketing",
        description3: "• Reach 20k Holders",
        description4: "• Reach 15k Telegram Members",
        buttonText: "Coming Soon!",
        icon: "cms",
    },
    {
        id: 4,
        buttonText: "Coming Soon!",
        end: "To be Announced!",
        icon: "cms",
    },
];

export default timelineElements;
